import { LocationEvidence, LocationVerificationDraft } from '@/types/LocationVerification.type';

export type LocationEvidenceSummary = {
  clientEvidenceId: string;
  role: LocationEvidence['role'];
  uploadState: LocationEvidence['uploadState'];
  hasImageUrl: boolean;
  hasPhoto: boolean;
  isReused: boolean;
};

export type DraftSummary = {
  inspectionId: string;
  workflowState: LocationVerificationDraft['workflowState'];
  evidenceCount: number;
  evidence: LocationEvidenceSummary[];
};

/**
 * Safe evidence summary for logs — never includes image bytes or URLs.
 */
export function summarizeLocationEvidence(evidence: LocationEvidence[]): LocationEvidenceSummary[] {
  return evidence.map((item) => ({
    clientEvidenceId: item.clientEvidenceId,
    role: item.role,
    uploadState: item.uploadState,
    hasImageUrl: Boolean(item.imageUrl),
    hasPhoto: item.hasPhoto !== false,
    isReused: Boolean(item.isReused),
  }));
}

export function summarizeDraft(draft: LocationVerificationDraft): DraftSummary {
  return {
    inspectionId: draft.inspectionId,
    workflowState: draft.workflowState,
    evidenceCount: draft.evidence.length,
    evidence: summarizeLocationEvidence(draft.evidence),
  };
}
